import { render, staticRenderFns } from "./DashboardAgentsCards.vue?vue&type=template&id=3fdd5bb1&"
import script from "./DashboardAgentsCards.vue?vue&type=script&lang=js&"
export * from "./DashboardAgentsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports